// The source bitmap and the image being traced can have different resolutions.
// Store the crop in source-bitmap pixels, not in the retraced image's pixels.
export const REFERENCE_ARTWORK_REGISTRATION_ATTR =
  "data-reference-artwork-registration";

const positive = (value) => Number.isFinite(Number(value)) && Number(value) > 0;
const coordinate = (value) =>
  Number.isFinite(Number(value)) ? Number(value) : 0;

export function createReferenceArtworkRegistration(
  sourceDimensions,
  traceDimensions,
  crop
) {
  const sourceWidth = Number(sourceDimensions?.[0] || traceDimensions?.[0]);
  const sourceHeight = Number(sourceDimensions?.[1] || traceDimensions?.[1]);
  const traceWidth = Number(traceDimensions?.[0] || sourceWidth);
  const traceHeight = Number(traceDimensions?.[1] || sourceHeight);
  if (![sourceWidth, sourceHeight, traceWidth, traceHeight].every(positive))
    return null;

  const percent = crop?.unit === "%";
  const basisWidth = percent ? 100 : traceWidth;
  const basisHeight = percent ? 100 : traceHeight;
  return {
    sourceWidth,
    sourceHeight,
    crop: {
      unit: "px",
      x: (coordinate(crop?.x) * sourceWidth) / basisWidth,
      y: (coordinate(crop?.y) * sourceHeight) / basisHeight,
      width:
        ((positive(crop?.width) ? Number(crop.width) : basisWidth) *
          sourceWidth) /
        basisWidth,
      height:
        ((positive(crop?.height) ? Number(crop.height) : basisHeight) *
          sourceHeight) /
        basisHeight,
    },
  };
}

// Keep the reference crop with the working SVG so save/reload restores its
// alignment with the vector without embedding private image data.
export function resolveReferenceArtworkRegistration(artwork, svg) {
  const stored = svg?.attributes?.[REFERENCE_ARTWORK_REGISTRATION_ATTR];
  if (!stored) return artwork;
  try {
    // svgson leaves XML entities in attribute values; URI encoding avoids
    // quote entities accumulating on successive saves.
    const registration = JSON.parse(decodeURIComponent(stored));
    const { sourceWidth, sourceHeight, crop } = registration;
    if (
      ![sourceWidth, sourceHeight, crop?.width, crop?.height].every(positive) ||
      ![crop?.x, crop?.y].every(
        (value) => typeof value === "number" && Number.isFinite(value)
      )
    )
      return artwork;
    return { ...artwork, sourceWidth, sourceHeight, crop };
  } catch {
    return artwork;
  }
}
